import type { ReactElement } from 'react';

const ProgramsItemSummary = (): ReactElement => (
  <>
    <span>
      Ready to Eat Breakfasts per Week
    </span>
    <div className="c-plan__item-total float-right">
      4
    </div>
    <hr />
    <span>
      Ready to Eat Lunches per Week
    </span>
    <div className="c-plan__item-total float-right">
      4
    </div>
    <hr />
    <span>
      Ready to Eat Dinners per Week
    </span>
    <div className="c-plan__item-total float-right">
      4
    </div>
    <hr />
  </>
);

export default ProgramsItemSummary;
